import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";

export class ContractList extends ListStoreConstructor<any> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getContractList(params).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        defaultSorters: { statusDate: "desc" },
        pollingInterval: 10000,
      }
    );
  }
}
